import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Admin } from "./Admin.tsx";
import { App } from "./App.tsx";
import { History } from "./History.tsx";
import "./index.css";

const path = location.pathname;
const page = path.startsWith("/admin") ? <Admin /> : path.startsWith("/me") ? <History /> : <App />;

createRoot(document.getElementById("root")!).render(<StrictMode>{page}</StrictMode>);
